<template>
  <v-row class="pt-0" wrap>
    <v-col cols="12" md="10">
      <v-card :flat="'xs' !== $mq" :outlined="'xs' === $mq" class="pa-5">
        <h2 class="font-weight-bold">{{
          getShopDetail('Not Taking Orders')
        }}</h2>
        <h3
          >We're not accepting orders at the moment. Please check back soon or
          email us with any questions.</h3
        >
        <v-btn
          :href="`mailto:${getShopDetail('Contact Email')}`"
          color="blue darken-2"
          class="mt-2"
          outlined
          >Send Email</v-btn
        >
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NoAvailabilityMsg',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('shop', ['getShopDetail']),
  },
}
</script>
